import { ref } from "vue"

export function createCallbacks(defaultCallbacks) {

    const callbacks = ref(defaultCallbacks)

    const hasCallback = (type) => callbacks.value[type] !== undefined

    return {
        callbacks   : callbacks,

        hasCallback : hasCallback,

        /**
         * Adds a new callback for a given type
         * 
         * @param {String} type 
         * @param {Function} callback 
         * @returns {*}
         */
        add : (type, callback) => callbacks.value[type] === undefined
            ? callbacks.value[type] = [callback] 
            : callbacks.value[type].push(callback),

        /**
         * Runs all callbacks defined for existing types
         * 
         * @param {String} type 
         * @returns {*}
         */
        run: async function(type) {
            if(!hasCallback(type)){
                return false
            }

            const callbacksForType = callbacks.value[type]

            if(Array.isArray(callbacksForType)){                
                for await (let callback of callbacksForType){
                    await callback(...[...arguments].splice(1))
                }
            } else if(callbacksForType instanceof Function){
                await callbacksForType(...[...arguments].splice(1))
            }
        }
    }

}